module.exports = __webpack_public_path__ + "media/images/athletes/1313-addb9f38696fec5c9c4b8cf0ff13edc0.png";